import { gql } from '@efficiently/client-core-graphql-models';

export const PROJECT_DOCUMENT_CREATORS = gql(`
	query ProjectDocumentCreators($projectId: String!) {
		projectDocumentCreators(projectId: $projectId) {
			_id
			name
		}
	}
`);
